import Header from './components/Header';
import Hero from './components/Hero';
import AboutSection from './components/AboutSection';
import CardsSection from './components/CardsSection';
import UpdatesSection from './components/UpdatesSection';
import CommentsSection from './components/CommentsSection';
import AppSection from './components/AppSection';
import RankingSection from './components/RankingSection';
import IndexSection from './components/IndexSection';
import FAQSection from './components/FAQSection';
import ContactSection from './components/ContactSection';
import CarouselSection from './components/CarouselSection';
import TopicsSection from './components/TopicsSection';
import FeaturesSection from './components/FeaturesSection';
import MediaSection from './components/MediaSection';
import Footer from './components/Footer';
import { useEffect } from 'react';

export default function Home() {
  useEffect(() => {
    const handleHashChange = () => {
      const hash = window.location.hash;
      if (hash) {
        setTimeout(() => {
          const el = document.querySelector(hash);
          if (el) {
            el.scrollIntoView({ behavior: 'smooth' });
          }
        }, 100);
      }
    };
    handleHashChange();
    window.addEventListener('hashchange', handleHashChange);
    return () => window.removeEventListener('hashchange', handleHashChange);
  }, []);

  return (
    <>
      <Header />
      <main>
        <Hero />
        <AboutSection />
        <CardsSection />
        <UpdatesSection />
        <CommentsSection />
        <AppSection />
        <RankingSection />
        <IndexSection />
        <FAQSection />
        <ContactSection />
        <CarouselSection />
        <TopicsSection />
        <FeaturesSection />
        <MediaSection />
      </main>
      <Footer />
    </>
  );
}